export default {
  GET_BABY_DRUM: (state, payload) => {
    state.babyDrum = payload
  }
}